module.exports = {
  "country": "MT",
  "artist": "Mary Spiteri",
  "song": "Little Child",
  "year": "1992",
  "place": "3",
  "spotify": "6jQ1TWGhShk7oMrvBOL173"
};